// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// luismrosero1992@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyDi87EoDK4mv13rJPy2U8Kcwt-Z51fFv3o",
    authDomain: "funnels-nebo-system.firebaseapp.com",
    projectId: "funnels-nebo-system",
    storageBucket: "funnels-nebo-system.firebasestorage.app",
    messagingSenderId: "394405715722",
    appId: "1:394405715722:web:0750fd80669e083b1ea4f3",
    measurementId: "G-N3T5M0FVZ8"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
//export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)